import React from 'react';
import { useSelector } from 'react-redux';
import { selectTranslations } from '../../config/i18n/slice';
import { Button, Divider } from 'semantic-ui-react';
import { useHistory } from "react-router";

const EmptyFilter = ({customer=true, vendor=false}) => {
    const t = useSelector(selectTranslations);
        const history = useHistory();
  return (
    // <div className="filters">
    //     <div className="text-right mb-5 pb-5 d-flex justify-content-between align-items-center views">
    //       <div className="list-view-option">
    //       <p className="single-view">
    //           <NavLink to="/customers">{t.customers.customer}</NavLink>
    //         </p>
    //         <p className="single-view">
    //           <NavLink to="/vendors">{t.customers.vendor}</NavLink>
    //         </p>
    //       </div>
    //     </div>
    //   </div>

    <div className="table-header-dashbaord team-filter filters">
    <Button.Group
      className="add-people-btn part"
      basic
      fluid
      size="medium"
    >
      <Button type="button" onClick={() => history.push("/customers")} active={customer}>
      {t.customers.customer}
      </Button>

      <Button type="button"  active={vendor} onClick={() => history.push("/vendors")}>
      {t.customers.vendor}
      </Button>
    </Button.Group>

    <Divider className="part-divider mt-0 mb-8" />
  </div>
  )
}

export default EmptyFilter